// src/pages/login.jsx
import React, { useState } from 'react';
import { authAPI, apiUtils } from '../services/api';
import { toast } from 'react-hot-toast';

const Login = () => {
    const [formData, setFormData] = useState({
        email: '',
        password: '',
    });
    const [loading, setLoading] = useState(false);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        try {
            const response = await authAPI.login(formData);
            apiUtils.setAuthData(response.data.token, response.data.user);
            toast.success('Login successful!');

            const user = response.data.user;
            switch (user.role) {
                case 'admin': window.location.href = '/admin/dashboard'; break;
                case 'faculty': window.location.href = '/faculty/dashboard'; break;
                case 'student': window.location.href = '/student/dashboard'; break;
                case 'parent': window.location.href = '/parent/dashboard'; break;
                default: window.location.href = '/';
            }
        } catch (error) {
            toast.error(apiUtils.formatError(error));
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="page-wrapper">
            <div className="header-section">
                <div className="logo-container">
                    <svg className="logo-icon" viewBox="0 0 24 24" fill="currentColor">
                        <path d="M9 11.75c-.69 0-1.25.56-1.25 1.25s.56 1.25 1.25 1.25 1.25-.56 1.25-1.25-.56-1.25-1.25-1.25zm6 0c-.69 0-1.25.56-1.25 1.25s.56 1.25 1.25 1.25 1.25-.56 1.25-1.25-.56-1.25-1.25-1.25zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8 0-.29.02-.58.05-.86 2.36-1.05 4.23-2.98 5.21-5.37C11.07 8.33 14.05 10 17.42 10c.78 0 1.53-.09 2.25-.26.21.71.33 1.47.33 2.26 0 4.41-3.59 8-8 8z" />
                    </svg>
                </div>
                <h1>Face Attendance</h1>
                <p>Smart biometric attendance system</p>
            </div>

            <form onSubmit={handleSubmit}>
                <div className="form-group">
                    <label className="form-label">Email</label>
                    <div className="input-container">
                        <input
                            type="email"
                            name="email"
                            placeholder="Enter your email"
                            required
                            value={formData.email}
                            onChange={handleChange}
                        />
                    </div>
                </div>

                <div className="form-group">
                    <label className="form-label">Password</label>
                    <div className="input-container">
                        <input
                            type="password"
                            name="password"
                            placeholder="Enter your password"
                            required
                            value={formData.password}
                            onChange={handleChange}
                        />
                    </div>
                </div>

                <button type="submit" disabled={loading} className="btn-submit">
                    {loading ? 'Logging in...' : 'Login'}
                </button>
            </form>

            <div className="role-section">
                <p className="role-section-label">Select Role</p>
                <div className="role-grid">
                    <div className="role-card">
                        <div className="role-card-icon">🎓</div>
                        <div className="role-card-title">Student</div>
                    </div>
                    <div className="role-card">
                        <div className="role-card-icon">👤</div>
                        <div className="role-card-title">Faculty</div>
                    </div>
                    <div className="role-card">
                        <div className="role-card-icon">⚙️</div>
                        <div className="role-card-title">Admin</div>
                    </div>
                    <div className="role-card">
                        <div className="role-card-icon">👨‍👩‍👧</div>
                        <div className="role-card-title">Parent</div>
                    </div>
                </div>
            </div>

            <div className="footer-links">
                <p>
                    <a href="/downloads" style={{ fontWeight: '500', color: 'var(--primary-color)' }}>Download App</a> | Don't have an account? <a href="#">Register here</a>
                </p>
            </div>
        </div>
    );
};

export default Login;